export default __webpack_public_path__ + "static/media/5@3x.bcf65ed4.png";